// extracted by mini-css-extract-plugin
module.exports = {"parameters":"parameters_editor__parameters___5WpWr"};